import HT from 'handsontable';
import { toNumberString } from 'helpers';

export function numericRenderer(...args: Parameters<typeof HT.renderers.NumericRenderer>): void {
  const [, TD, , , , value] = args;
  HT.renderers.NumericRenderer.apply(this, args);
  TD.innerText = toNumberString(value);
}
